import { menuItem } from 'base/ui/menu_model';
import { BlocksService } from 'blocks/blocks_service';
import { ConfirmDeleteDialog } from 'blocks/dashboard/projects_list/confirm_delete';
import { dashboardRouteToUrl } from 'blocks/dashboard/routes';
import { observable } from 'mobx';
import React from 'react';
import { Project } from '../model';

export function createDeleteDialog(
  project: Project,
  projectToken: string,
  blocksService: BlocksService,
) {
  async function doDelete() {
    await blocksService.projectDelete({ projectToken });
    window.location.href = dashboardRouteToUrl({ path: 'dashboard' });
  }

  const dialogBox = observable.box<React.ReactElement | undefined>();
  function confirmDelete() {
    if (dialogBox.get()) return;
    const name = project.name || 'Untitled Project';
    dialogBox.set(
      <ConfirmDeleteDialog
        name={name}
        onCancel={() => dialogBox.set(undefined)}
        doDelete={doDelete}
      />,
    );
  }

  return {
    menuItem: menuItem({ label: 'Delete project', onClick: confirmDelete }),
    getDialog: () => dialogBox.get(),
  };
}
